import { render, staticRenderFns } from "./ResendEmailModal.vue?vue&type=template&id=9c80e9e0&"
import script from "./ResendEmailModal.vue?vue&type=script&lang=js&"
export * from "./ResendEmailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports